import { EFinancingProgram } from '@if/core/types'
import { formatCurrencyNoDecimals } from '@if/core/utils'
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material'
import { alpha, Card, CardContent, Grid, IconButton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ClickableAddress from '../../../../../../../components/AddressWithGoogleSearch'
import { useCurrentLang, useJobTypeEnum } from '../../../../../../../data/selectors/app-config-selectors'
import { ApplicantJob } from '../../../../../../../data/types'

interface Props {
  onDelete?: () => void
  onEdit?: () => void
  data: ApplicantJob
  hasError?: boolean
  editDisabled: boolean
  financingProgramId: EFinancingProgram | null
}

const DisplayJobInfosComponent = ({
  onDelete,
  onEdit,
  data,
  hasError = false,
  editDisabled,
  financingProgramId,
}: Props) => {
  const { t } = useTranslation()
  const { address } = data
  const jobTypeEnum = useJobTypeEnum(financingProgramId)
  const lang = useCurrentLang()

  return (
    <Card
      sx={{
        width: '100%',
        mb: 1,
        ...(hasError && {
          border: 1,
          borderColor: 'error.main',
          bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
        }),
      }}
    >
      <CardContent>
        <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
          <Grid
            size={{
              xs: 12,
              sm: 11,
            }}
          >
            <Typography variant="h6">{`${data.employerName} (${jobTypeEnum[data.jobType.toString()][lang]}) : ${
              data.jobTitle
            } ${formatCurrencyNoDecimals(data.annualSalary)}`}</Typography>
            <ClickableAddress address={address} typographyProps={{ variant: 'body2' }} />
            {hasError && (
              <Typography variant="body2" color="error">
                {t('editCreditApplication.income.job.invalid')}
              </Typography>
            )}
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 1,
            }}
          >
            <Stack direction="row">
              {onDelete && (
                <IconButton aria-label="delete" onClick={onDelete} disabled={editDisabled}>
                  <DeleteIcon />
                </IconButton>
              )}
              {onEdit && (
                <IconButton aria-label="edit" onClick={onEdit} disabled={editDisabled}>
                  <EditIcon />
                </IconButton>
              )}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default DisplayJobInfosComponent
